import { IApplication } from '../types';

// "Aprovado" não entra aqui de propósito: esta coluna é só a posição frente às vagas, e
// a Secretaria leu o rótulo como deferimento. Aprovado existe só na coluna Situação, que
// vem do backend e só muda quando ela aprova a documentação.
export type IVacancyResult = 'Classificado' | 'Classificado Excedente' | 'Excedente' | '-';

// Vagas por série, no formato em que o vacancies_board devolve (onboarding_id -> vagas).
export type IVacancies = { [onboardingId: number]: number | null };

const NO_CLASSIFICATION = Number.MAX_SAFE_INTEGER;

export const byClassification = (a: IApplication, b: IApplication): number => {
  const left = a.classification == null ? NO_CLASSIFICATION : a.classification;
  const right = b.classification == null ? NO_CLASSIFICATION : b.classification;

  return left === right ? a.id - b.id : left - right;
};

export const groupByOnboarding = (applications: IApplication[]): { [id: number]: IApplication[] } => {
  const groups: { [id: number]: IApplication[] } = {};

  applications.forEach(application => {
    const id = application.desired_onboarding.id;

    groups[id] = (groups[id] || []).concat(application);
  });

  return groups;
};

// Posição do candidato frente às vagas da sua série. Reprovado não ocupa vaga e sai
// da disputa; quem entra por causa de uma reprovação acima é "Classificado Excedente".
export const vacancyResults = (
  applications: IApplication[],
  vacancies: IVacancies,
): { [applicationId: number]: IVacancyResult } => {
  const results: { [applicationId: number]: IVacancyResult } = {};
  const groups = groupByOnboarding(applications);

  Object.keys(groups).forEach(key => {
    const onboardingId = Number(key);
    const total = vacancies[onboardingId];
    const ordered = groups[onboardingId].slice().sort(byClassification);

    if (total == null) {
      ordered.forEach(application => { results[application.id] = '-'; });

      return;
    }

    let taken = 0;

    ordered.forEach((application, index) => {
      if (application.status === 'Reprovado' || application.status === 'Eliminado') {
        results[application.id] = '-';

        return;
      }

      if (taken < total) {
        taken += 1;
        results[application.id] = index < total ? 'Classificado' : 'Classificado Excedente';

        return;
      }

      results[application.id] = 'Excedente';
    });
  });

  return results;
};
